import React, { useEffect, useState } from 'react';
import collaborativeIcon from "../../../../Assets/Images/CollabrativeIcon.png";
import visionary from "../../../../Assets/Images/VISIONARY.png";
import strategic from "../../../../Assets/Images/StrategicIcon.png";
import performance from "../../../../Assets/Images/PerformaceIcon.png";
import Heart from "../../../../Assets/Images/HEART.png";
import Soul from "../../../../Assets/Images/SOUL.png";
import Mind from "../../../../Assets/Images/MIND.png";
import Strength from "../../../../Assets/Images/STRENGTH.png";
import HeaderPreview from "../../../GeneratePdf/HeaderPreview";
import FooterPreview from "../../../GeneratePdf/FooterPreview";

const initialData = [
  { quadrant: 'PERFORMANCE', no: 1, question: 'When leading through conflict, my goal is to accomplish our objective by any means necessary.', score: 1 },
  { quadrant: 'STRATEGIC', no: 1, question: 'When leading through conflict, I follow a specific process to work through it.', score: 2 },
  { quadrant: 'VISIONARY', no: 1, question: 'When leading through conflict, I can envision how this particular circumstance fits within a larger story.', score: 3 },
  { quadrant: 'COLLABORATIVE', no: 1, question: 'When leading through conflict, I am attuned to the feelings everyone is experiencing.', score: 4 },
  { quadrant: 'COLLABORATIVE', no: 2, question: 'I am at my best when I feel more deeply connected to others.', score: 4 },
  { quadrant: 'PERFORMANCE', no: 2, question: 'I am at my best when I am driving others to deliver results.', score: 1 },
  { quadrant: 'VISIONARY', no: 2, question: 'I am at my best when casting a vision of where we should be heading.', score: 3 },
  { quadrant: 'STRATEGIC', no: 2, question: 'I am at my best when creating standardized processes that help others achieve their goals more easily.', score: 2 },
  { quadrant: 'VISIONARY', no: 3, question: 'I believe stories help communicate the core values of an organization.', score: 3 },
  { quadrant: 'COLLABORATIVE', no: 3, question: 'I want to build an emotionally intelligent organization.', score: 4 },
  { quadrant: 'STRATEGIC', no: 3, question: 'I believe leading an organization requires a unified set of operating principles.', score: 2 },
  { quadrant: 'PERFORMANCE', no: 3, question: 'I am motivated by organizations that prioritize measurable results.', score: 1 },
];

const Logo = (quadrant) => {
  switch (quadrant) {
    case 'COLLABORATIVE':
      return <img src={collaborativeIcon} alt="Collaborative" className="logo" />;
    case 'VISIONARY':
      return <img src={visionary} alt="Visionary" className="logo" />;
    case 'STRATEGIC':
      return <img src={strategic} alt="Strategic" className="logo" />;
    case 'PERFORMANCE':
      return <img src={performance} alt="Performance" className="logo" />;
    case 'HEART':
      return <img src={Heart} alt="Heart" className="logo" />;
    case 'SOUL':
      return <img src={Soul} alt="Soul" className="logo" />;
    case 'MIND':
      return <img src={Mind} alt="Mind" className="logo" />;
    case 'STRENGTH':
      return <img src={Strength} alt="Strength" className="logo" />;
    default:
      return null;
  }
};

const truncateText = (text, limit) => {
  if (text.length <= limit) return text;
  return text.substring(0, text.lastIndexOf(" ", limit)) + "...";
};

const Item = ({ apiData, pageNumber }) => {
  const [dynamicData, setDynamicData] = useState([...initialData]);

  useEffect(() => {
    if (!apiData || !apiData.variables || !apiData.variables.length) {
      setDynamicData(initialData);
      return;
    }

    const questions = [];

    apiData.variables.forEach(item => {
      const match = item.variable?.match(/^ls(\d+)_self_pass([12])$/);
      if (!match) return;

      const rawNo = parseInt(match[1]);
      const passType = match[2];

      let actualScore;
      let actualQuestionNo;

      if (rawNo >= 1 && rawNo <= 10) {
        actualScore = passType === "1" ? 4 : 1;
        actualQuestionNo = rawNo;
      } else if (rawNo >= 11 && rawNo <= 20) {
        actualScore = passType === "1" ? 3 : 2;
        actualQuestionNo = rawNo - 10;
      } else {
        return;
      }

      questions.push({
        questionNo: actualQuestionNo,
        rawNo: rawNo,
        passType,
        actualScore,
        updatedAt: item.updatedAt,
        variable: item.variable,
        score: item.score,
      });
    });

    const latestScoresMap = new Map();

    questions.forEach(question => {
      const key = `${question.questionNo}_${question.score}`;
      const existing = latestScoresMap.get(key);

      if (!existing || question.rawNo > 10) {
        latestScoresMap.set(key, question);
      }
    });

    const updatedData = initialData.map(item => {
      const matchingQuestion = Array.from(latestScoresMap.values())
        .find(q => q.questionNo === item.no && q.score === item.score);

      return {
        ...item,
        score: matchingQuestion ? matchingQuestion.actualScore : '-'
      };
    });

    setDynamicData(updatedData);
  }, [apiData]);



  const categoryMeta = [
    { label: "CONFLICT", color: "#394554" },
    { label: "PEAK PERFORMANCE", color: "#666666" },
    { label: "GUIDING VALUES", color: "#394554" }
  ];

  const categories = categoryMeta.map((meta, idx) => ({
    ...meta,
    rows: dynamicData.slice(idx * 4, idx * 4 + 4),
  }));

  return (
    <div>
      <HeaderPreview apiData={apiData} />
      <div className="page">
        <div className="headerBox">
          <h2 className="title">LEADERSHIP FLOW ITEMS OVERVIEW</h2>
          <p className="subTitle">
            This page presents a ranking of all 40 items distributed across the four leadership scales: Collaborative, Visionary, Strategic, and Performance. The rankings are based on self-ratings provided by participants, using a response scale that ranges from 1 (Least) to 4 (Most). Any unselected statement will appear as "-" in the Items Overview chart.          </p>
        </div>

        <div className="content">
          <div className="table">
            <table>
              <thead>
                <tr className="tableHeader">
                  <th className="cellBandHeader"></th>
                  <th className="cellIndex">#</th>
                  <th className="cellQuadrant" style={{ paddingLeft: "0", width: "65px" }}>Quadrant</th>
                  <th className="cellLogo"></th>
                  <th className="cellQuestion-self">Question</th>
                  <th className="cellScore" style={{ padding: "0 5px" }}>Score</th>
                </tr>
              </thead>
              <tbody>
                {categories.map((category, catIdx) =>
                  category.rows.map((item, rowIdx) => {
                     const rowNumber = catIdx * 4 + rowIdx + 1;
                    const isCategoryStart = rowIdx === 0;
                    const isCategoryEnd = rowIdx === category.rows.length - 1;
                    const rowClass = `tableRow ${isCategoryStart ? 'categoryStart' : ''} ${isCategoryEnd ? 'categoryEnd' : ''}`.trim();

                    return (
                      <tr key={`${category.label}-${rowIdx}`} className={rowClass}>
                        {isCategoryStart && (
                          <td
                            className="cellBand categoryBand"
                            rowSpan={category.rows.length || 4}
                            style={{ backgroundColor: category.color }}
                          >
                            <span className="bandLabel">{category.label}</span>
                          </td>
                        )}
                        <td className="cellIndex">{rowNumber}.</td>
                        <td className="cellQuadrant" style={{ width: "75px", padding: "0" }}>{item.quadrant}</td>
                        <td className="" style={{ width: "14px", height: "100%" }}>{Logo(item.quadrant)}</td>
                        <td className="cellQuestion-self">{item.question}</td>
                        <td className="cellScore">{typeof item.score === 'number' ? item.score : '-'}</td>
                      </tr>
                    );
                  })
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <FooterPreview pageNumber={pageNumber} />
    </div>
  );
};

export default Item;
